import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import bg from "./bg/signin.svg";
import bgimg from "./bg/backimg.jpg";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { useState, forwardRef } from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Slide from "@mui/material/Slide";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { eyeOff } from 'react-icons-kit/feather/eyeOff';
import { eye } from 'react-icons-kit/feather/eye'
import { Icon } from 'react-icons-kit';
import { useFormik } from "formik";
import * as yup from "yup";
import { makeApiRequest } from "../axiosService/apiCall";

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const darkTheme = createTheme({
  palette: {
    mode: "dark",
  },
});

const boxstyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "75%",
  // height: "70%",
  bgcolor: "background.paper",
  boxShadow: 24,
};

const center = {
  position: "relative",
  top: "50%",
  left: "37%",
};

export default function ResetPassword() {
  const { token } = useParams();
  const [open, setOpen] = useState(false);
  const [password, setPassword] = useState("")
  const [confirm, setConfirm] = useState("")

  const vertical = "top";
  const horizontal = "right";
  const navigate = useNavigate();
  const [type, setType] = useState('password');
  const [icon, setIcon] = useState(eyeOff);
  const [confirmtype, setConfirmtype] = useState('password');
  const [confirmicon, setConfirmicon] = useState(eyeOff);
  

  const formik = useFormik({
    initialValues: {
      NewPassword: "",
      ConfirmPassword: "",
    },
    validationSchema: yup.object().shape({
      NewPassword: yup
        .string()
        .required("Please Enter your New Password...")
        .min(8, "Password must be at least 8 characters long")
        .matches(/[a-z]/, "Password must contain at least one lowercase letter")
        .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
        .matches(/\d/, "Password must contain at least one number")
        .matches(
          /[!@#$%^&*(),.?":{}|<>]/,
          "Password must contain at least one special character"
        ),
      ConfirmPassword: yup
        .string()
        .required("Please Enter your Confirm Password...")
        .min(8, "Password must be at least 8 characters long")
        .matches(/[a-z]/, "Password must contain at least one lowercase letter")
        .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
        .matches(/\d/, "Password must contain at least one number")
        .matches(
          /[!@#$%^&*(),.?":{}|<>]/,
          "Password must contain at least one special character"
        ),
    }),
    onSubmit: async (values) => {
      try {
        const params = {
          url: `reset-password/${token}`,
          method: "POST",
          data: {
            newpassword: values.NewPassword,
            confirmpassword: values.ConfirmPassword,
          },
        };
        const response = await makeApiRequest(params);
   

        if (response.status === true) {
          toast.success(response.message);
          setTimeout(() => {
            navigate("/");  // Redirect to login after successful password reset
          }, 1000);
        } else {
          toast.error(response.message);
        }
      } catch (err) {
        console.error(err);
        toast.error("Something went wrong!");
      }
    },
  });
  const handleToggle = () => {
    setIcon(type === 'password' ? eye : eyeOff);
    setType(type === 'password' ? 'text' : 'password');
  }


  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  function TransitionLeft(props) {
    return <Slide {...props} direction="left" />;
  }

  return (
    <>
      <ToastContainer />
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={handleClose}
        TransitionComponent={TransitionLeft}
        anchorOrigin={{ vertical, horizontal }}
      >
        <Alert onClose={handleClose} severity="error" sx={{ width: "100%" }}>
          Failed! Password Does Not Match.
        </Alert>
      </Snackbar>
      <div
        style={{
          backgroundColor: "rgba(9, 116, 155, 1)",
          backgroundSize: "cover",
          height: "100vh",
          color: "#f5f5f5",
        }}
      >
        <Box sx={boxstyle}>
          <Grid container>
            <Grid item xs={12} sm={12} lg={6}>
              <Box
                style={{
                  backgroundImage: `url(${bg})`,
                  backgroundSize: "cover",
                  marginTop: "40px",
                  marginLeft: "15px",
                  marginRight: "15px",
                  height: "63vh",
                  color: "#f5f5f5",
                }}
              ></Box>
            </Grid>
            <Grid item xs={12} sm={12} lg={6}>
              <Box
                style={{
                  backgroundSize: "cover",
                  height: "70vh",
                  minHeight: "500px",
                  backgroundColor: "rgba(9, 116, 155, 1)",
                }}
              >
                <ThemeProvider theme={darkTheme}>
                  <Container>
                    <Box height={35} />
                    <Box sx={center}>
                      <Avatar sx={{ ml: "85px", mb: "4px", bgcolor: "#ffffff" }}>
                        <LockOutlinedIcon />
                      </Avatar>
                      <Typography component="h1" variant="h5">
                        Reset Password
                      </Typography>
                    </Box>


                      <Box component="form" noValidate sx={{ mt: 2 }}>
                        <Grid container spacing={1}>
                          <Grid item xs={12} sx={{ ml: "3em", mr: "3em" }} className="position-relative">
                            <div className=" mt-3">
                              <TextField
                                required
                                fullWidth
                                type={type}
                                name="NewPassword"
                                label="Password"
                                value={formik.values.NewPassword}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                id="password"
                                autoComplete="NewPassword"

                              />
                            </div>
                            <div className="new-password-positioning" style={{ width: "fit-content" }}>
                              <Icon class="absolute mr-10" icon={icon} size={25} onClick={handleToggle} />
                            </div>
                          </Grid>

                          <Grid item xs={12} sx={{ ml: "3em", mr: "3em" }} className="position-relative">
                            <div className=" mt-3">
                              <TextField
                                required
                                fullWidth
                                type={type}
                                name="ConfirmPassword"
                                label="Confirm Password"
                                value={formik.values.ConfirmPassword}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                id="confirm"
                                autoComplete="ConfirmPassword"

                              />
                            </div>
                            <div className="new-password-positioning" style={{ width: "fit-content" }}>
                              <Icon class="absolute mr-10" icon={confirmicon} size={25} />
                            </div>
                          </Grid>

                          <Grid item xs={12} sx={{ ml: "5em", mr: "5em" }}>
                            <Button onClick={formik.handleSubmit}
                              type="submit"
                              variant="contained"
                              fullWidth="true"
                              size="large"
                              sx={{
                                mt: "10px",
                                mr: "20px",
                                borderRadius: 28,
                                color: "#ffffff",
                                minWidth: "170px",
                                backgroundColor: "#FF9A01",
                              }}
                            >
                              Submit
                            </Button>
                          </Grid>
                        </Grid>
                      </Box>
                  </Container>
                </ThemeProvider>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </div>
    </>
  );
}






